module.exports = __webpack_public_path__ + "static/media/icon-music-instruments.0281d76e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-music-instruments.svg
// module id = 999
// module chunks = 0